import type { StartNewRelicParameter } from './NewRelic.types'
import type { ContextConfigFile } from './request.types'

export function getNewRelicWarning(
  startNewRelicParameter: Partial<StartNewRelicParameter>,
) {
  const keys = [
    'accountID',
    'trustKey',
    'agentID',
    'licenseKey',
    'applicationID',
    'beacon',
    'errorBeacon',
    'sa',
  ]
  return keys
    .filter((key) => `${startNewRelicParameter[key] ?? ''}` === '')
    .map((key) => `'${key}' is missing`)
    .join(', ')
}

export function getNewRelicParameters(context: ContextConfigFile) {
  const startNewRelicParameter: StartNewRelicParameter = {
    accountID: context.newrelic_accountID,
    trustKey: context.newrelic_trustKey,
    agentID: context.newrelic_agentID,
    licenseKey: context.newrelic_licenseKey,
    applicationID: context.newrelic_applicationID,
    beacon: context.newrelic_beacon,
    errorBeacon: context.newrelic_errorBeacon,
    sa: context.newrelic_sa,
    allowedOrigins: context.newrelic_allowed_origins?.split(','),
    corsUseNewrelicHeader: context.newrelic_cors_use_newrelic_header,
    corsUseTraceContextHeaders: context.newrelic_cors_use_trace_context_headers,
  }

  return startNewRelicParameter
}
